import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center bg-charcoal text-white/60">Loading…</div>;
  }
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
};
